




















import { Vue, Component, Prop } from 'vue-property-decorator';
import { IconSize } from '@getaccept/lib-ui';
import type { RainbowColor } from '../../styles/enums/RainbowColor';
import BaseH5 from '../base-headings/_base-h5.vue';
import { RainbowColorHelper } from '../../styles/helpers/rainbow-color.helper';
import type { StatusType } from './types/status-type';

@Component({
  name: 'BaseStatusBadge',
  components: {
    BaseH5,
  },
  data() {
    return {
      IconSize,
    };
  },
})
export default class BaseStatusBadge extends Vue {
  @Prop() statusType: StatusType;
  @Prop() text: string;
  @Prop() border: boolean;
  @Prop() color?: RainbowColor;
  @Prop({ default: true }) enableMinWidth: boolean;
  @Prop() dataExternal?: string;
  @Prop() icon?: string;

  get textColor(): string {
    return this.color ? RainbowColorHelper.text(this.color) : '';
  }

  get colorClass(): string {
    return this.color ? RainbowColorHelper.background(this.color) : null;
  }
}
